/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Faq_Q5Inputs */

const en_diff_faq_q5 = /** @type {(inputs: Diff_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I compare very large JSON files?`)
};

const ko_diff_faq_q5 = /** @type {(inputs: Diff_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매우 큰 JSON 파일을 비교할 수 있나요?`)
};

const ja_diff_faq_q5 = /** @type {(inputs: Diff_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非常に大きなJSONファイルを比較できますか？`)
};

/**
* | output |
* | --- |
* | "Can I compare very large JSON files?" |
*
* @param {Diff_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_faq_q5 = /** @type {((inputs?: Diff_Faq_Q5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Faq_Q5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_faq_q5(inputs)
	if (locale === "ko") return ko_diff_faq_q5(inputs)
	return ja_diff_faq_q5(inputs)
});